export default __webpack_public_path__ + "static/media/17.2b2ca4d1.jpg";